/* yc-fix v5 (2026-08-07): iOS WebKit variant-selection fixes.
   Issue: on iOS, (1) the browser restores previous form values without firing change
   events, and (2) the options app (YMQ) rewinds the native selects between the change
   event and the theme's section request, so the product page showed the default
   variant's price/media while the cart was correct.
   Fix: record the user's intended selection at capture time and rewrite the
   option_values parameter of outgoing section requests; also dispatch a change after
   load when a restored select value differs from the server-rendered selection. */
(function () {
  var intent = {};
  function idForValue(sel, value) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === value) return sel.options[i].dataset ? sel.options[i].dataset.optionValueId : null;
    }
    return null;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.tagName === 'SELECT' && /^options\[/.test(t.name || '')) {
      if (t.selectedIndex < 0 && t.value) {
        for (var i = 0; i < t.options.length; i++) {
          if (t.options[i].value === t.value) { t.selectedIndex = i; break; }
        }
      }
      if (t.selectedOptions && t.selectedOptions.length) {
        for (var j = 0; j < t.options.length; j++) t.options[j].removeAttribute('selected');
        t.selectedOptions[0].setAttribute('selected', 'selected');
      }
      var vid = idForValue(t, t.value);
      if (vid) intent[t.name] = { id: vid, time: Date.now() };
    }
    if (t.tagName === 'INPUT' && t.type === 'radio' && /^options\[/.test(t.name || '') && t.checked && t.dataset && t.dataset.optionValueId) {
      intent[t.name] = { id: t.dataset.optionValueId, time: Date.now() };
    }
  }, true);
  function computeOptionValues() {
    var root = document.querySelector('variant-selects');
    if (!root) return null;
    var out = [];
    var els = root.querySelectorAll('select, fieldset input:checked');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], name = el.name || '', id = null;
      var rec = intent[name];
      if (rec && Date.now() - rec.time < 5000) {
        id = rec.id;
      } else if (el.tagName === 'SELECT') {
        var o = (el.selectedOptions && el.selectedOptions[0]) || null;
        if (!o && el.value) o = Array.prototype.find.call(el.options, function (x) { return x.value === el.value; });
        id = o && o.dataset ? o.dataset.optionValueId : null;
      } else {
        id = el.dataset ? el.dataset.optionValueId : null;
      }
      if (id) out.push(id);
    }
    return out.length ? out : null;
  }
  var of = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = String((input && input.url) || input);
      if (url.indexOf('option_values=') > -1) {
        var correct = computeOptionValues();
        if (correct) {
          var fixed = url.replace(/option_values=[0-9,%2C]+/, 'option_values=' + correct.join(','));
          if (fixed !== url) {
            if (typeof input === 'string' || input instanceof URL) { input = fixed; }
            else { input = new Request(fixed, input); }
          }
        }
      }
    } catch (err) {}
    return of.apply(this, [input, init]);
  };
  var synced = false;
  function syncRestoredSelects() {
    if (synced) return;
    var selects = document.querySelectorAll('variant-selects select');
    for (var i = 0; i < selects.length; i++) {
      var s = selects[i];
      var live = s.selectedOptions && s.selectedOptions[0];
      var attr = Array.prototype.find.call(s.options, function (o) { return o.hasAttribute('selected'); });
      if (live && attr && live !== attr) {
        synced = true;
        s.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }
  window.addEventListener('pageshow', function () { setTimeout(syncRestoredSelects, 400); });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(syncRestoredSelects, 800); });
})();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
